var getRequestAsPromise = function(method, url, headers, returnRequestHandleOnResolve, returnRequestHandleOnReject, data){
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.open(method || "GET", url);
    if (headers) {
        Object.keys(headers).forEach(key => {
            xhr.setRequestHeader(key, headers[key]);
        });
    }
    xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
            if(returnRequestHandleOnResolve){ // Including this as we might need the request handle to fetch headers (example: range) in some cases (example: pagination / lazy loading).
                resolve(xhr);
            }else{
                resolve(xhr.response);
            }
        } else {
            if(returnRequestHandleOnReject){
                reject(xhr);
            }else{
                reject(xhr.statusText);
            }
        }
    };
    xhr.onerror = () => reject(xhr.statusText);
    if( data ) {
      xhr.send(data);
    } else {
      xhr.send();
    }
  });
}

export default getRequestAsPromise;